import { useCachedQuery } from '@kaiizen/react-persistent-cache';
import { useKaiProApiClient } from '../useKaiProApiClient';

export const usePropertySearch = (searchString: string, options?: { limit?: number; includeArchived?: boolean }) => {
  const kaiProApiClient = useKaiProApiClient();
  const trimmedSearchString = searchString.trim();

  const query = useCachedQuery(
    `propertySearch/${trimmedSearchString}/${options?.limit ?? 'default'}/${options?.includeArchived ? 'all' : 'active'}`,
    () => kaiProApiClient.searchProperties(trimmedSearchString, { limit: options?.limit, includeArchived: options?.includeArchived }),
    { enabled: !!kaiProApiClient.token && trimmedSearchString.length > 1, maxRetryMs: 0 },
  );

  return {
    results: query.data || [],
    isLoading: query.isLoading,
    searchAttempted: trimmedSearchString.length > 1,
  };
};
